/**
 * Főzde típusa   * SMALL_SCALE - kisüzemi   * LARGE_SCALE - nagyüzemi
 */
export type BreweryType = 'SMALL_SCALE' | 'LARGE_SCALE';

export const BreweryType = {
  SmallScale: 'SMALL_SCALE' as BreweryType,
  LargeScale: 'LARGE_SCALE' as BreweryType,
};
